// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UALADSFunctionalUnitFunctionSetInner } from './UALADSFunctionalUnitFunctionSetInner';
import {
    UALADSFunctionalUnitFunctionSetInnerFromJSON,
    UALADSFunctionalUnitFunctionSetInnerFromJSONTyped,
    UALADSFunctionalUnitFunctionSetInnerToJSON,
    UALADSFunctionalUnitFunctionSetInnerToJSONTyped,
} from './UALADSFunctionalUnitFunctionSetInner';
import type { UALADSFunctionalUnitProgramManager } from './UALADSFunctionalUnitProgramManager';
import {
    UALADSFunctionalUnitProgramManagerFromJSON,
    UALADSFunctionalUnitProgramManagerFromJSONTyped,
    UALADSFunctionalUnitProgramManagerToJSON,
    UALADSFunctionalUnitProgramManagerToJSONTyped,
} from './UALADSFunctionalUnitProgramManager';
import type { UAFunctionalState } from './UAFunctionalState';
import {
    UAFunctionalStateFromJSON,
    UAFunctionalStateFromJSONTyped,
    UAFunctionalStateToJSON,
    UAFunctionalStateToJSONTyped,
} from './UAFunctionalState';
import type { UALADSFunctionalUnitLock } from './UALADSFunctionalUnitLock';
import {
    UALADSFunctionalUnitLockFromJSON,
    UALADSFunctionalUnitLockFromJSONTyped,
    UALADSFunctionalUnitLockToJSON,
    UALADSFunctionalUnitLockToJSONTyped,
} from './UALADSFunctionalUnitLock';

/**
 * 
 * @export
 * @interface UALADSFunctionalUnit
 */
export interface UALADSFunctionalUnit {
    /**
     * 
     */
    browseName: string;
    /**
     * Canonical (source-side) browse path of this FunctionalUnit,
     * e.g. "DeviceSet/FreezerDevice@0815/FunctionalUnitSet/FreezerUnit".
     * For cross-mounted FUs (OrganizedFunctionalUnit) this is the
     * source path, NOT the mount/host path. Use this for overrides,
     * history queries, and source-device lookups.
     */
    browsePath: string;
    /**
     * 
     */
    displayName: string;
    /**
     * Class of the functional unit.
     * This can be used for manufacturer specific rendering for devices
     */
    type: string;
    /**
     * 
     */
    functionSet?: Array<UALADSFunctionalUnitFunctionSetInner>;
    /**
     * 
     */
    lock?: UALADSFunctionalUnitLock;
    /**
     * 
     */
    supportedPropertiesSet?: object;
    /**
     * 
     */
    functionalUnitState: UAFunctionalState;
    /**
     * AssetId is a user-writable alphanumeric character
     * sequence the uniquely identifies a FunctionalUnit
     * (see OPC UA 10000-100).
     */
    assetId?: string;
    /**
     * ComponentName is a user-writable name provided by
     * the integrator or user of the FunctionalUnit.
     */
    componentName?: string;
    /**
     * 
     */
    programManager?: UALADSFunctionalUnitProgramManager;
}



/**
 * Check if a given object implements the UALADSFunctionalUnit interface.
 */
export function instanceOfUALADSFunctionalUnit(value: object): value is UALADSFunctionalUnit {
    if (!('browseName' in value) || value['browseName'] === undefined) return false;
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('functionalUnitState' in value) || value['functionalUnitState'] === undefined) return false;
    return true;
}

export function UALADSFunctionalUnitFromJSON(json: any): UALADSFunctionalUnit {
    return UALADSFunctionalUnitFromJSONTyped(json, false);
}

export function UALADSFunctionalUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSFunctionalUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'browseName': json['browseName'],
        'browsePath': json['browsePath'],
        'displayName': json['displayName'],
        'type': json['type'],
        'functionSet': json['functionSet'] == null ? undefined : ((json['functionSet'] as Array<any>).map(UALADSFunctionalUnitFunctionSetInnerFromJSON)),
        'lock': json['lock'] == null ? undefined : UALADSFunctionalUnitLockFromJSON(json['lock']),
        'supportedPropertiesSet': json['supportedPropertiesSet'] == null ? undefined : json['supportedPropertiesSet'],
        'functionalUnitState': UAFunctionalStateFromJSON(json['functionalUnitState']),
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'componentName': json['componentName'] == null ? undefined : json['componentName'],
        'programManager': json['programManager'] == null ? undefined : UALADSFunctionalUnitProgramManagerFromJSON(json['programManager']),
    };
}

export function UALADSFunctionalUnitToJSON(json: any): UALADSFunctionalUnit {
    return UALADSFunctionalUnitToJSONTyped(json, false);
}

export function UALADSFunctionalUnitToJSONTyped(value?: UALADSFunctionalUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browseName': value['browseName'],
        'browsePath': value['browsePath'],
        'displayName': value['displayName'],
        'type': value['type'],
        'functionSet': value['functionSet'] == null ? undefined : ((value['functionSet'] as Array<any>).map(UALADSFunctionalUnitFunctionSetInnerToJSON)),
        'lock': UALADSFunctionalUnitLockToJSON(value['lock']),
        'supportedPropertiesSet': value['supportedPropertiesSet'],
        'functionalUnitState': UAFunctionalStateToJSON(value['functionalUnitState']),
        'assetId': value['assetId'],
        'componentName': value['componentName'],
        'programManager': UALADSFunctionalUnitProgramManagerToJSON(value['programManager']),
    };
}

